/**
 * Plugin jQuery que consome o postCard e retorna
 * RegEx com os bins válidos de cartoes de credito
 * aceitos pelo PostCard
 *
 * return: [bandeiras|null]
 * example: $.getFlagRegex(postCardBrandUrl);
 *
 * @depends jquery.m4u.getFlagRegex.js
 */
jQuery(function($) {
  $.getFlagRegex = $.fn.getFlagRegex = function(postCardBrandUrl) {
    var bin;
    var arrayRetorno = [];
    var identificacaoFlagRegex = [];

    $.get(postCardBrandUrl, function(data) {
      $.each(data, function(flag, bins) {
        bin = bins.join('|');
        bin = "^" + bin.replace(/\%\|/g, "|^").replace('%', '');
        identificacaoFlagRegex.push([flag, bin]);
      });

      identificacaoFlagRegex.sort(function(a, b) {
        return a[1].length - b[1].length;
      });

      $.each(identificacaoFlagRegex.reverse(), function(i, ar) {
        arrayRetorno[ar[0]] = new RegExp(ar[1])
      });
    });

    return arrayRetorno;
  };
});



// WEBPACK FOOTER //
// ./src/js/vendor/jquery.m4u.getFlagRegex.js